export const getContentNames = (contents, t) => {
    const i18nAnd = t('LIVE_SEND_VIEWER_AND');
    const i18nMore = t('LIVE_SEND_VIEWER_MORE');
    const fileNames = contents
        .slice(0, 4)
        .map((c, index) => {
            if (index < 2) {
                return `${c.name},`;
            } else if (index === 2) {
                return `${i18nAnd} ${c.name}`;
            }

            return `${i18nAnd} ${i18nMore}`;
        })
        .join(' ');

    if (fileNames.endsWith(',')) {
        return fileNames.substr(0, fileNames.length - 1);
    }

    return fileNames;
};
